import { ChoicesInput } from "./ChoicesInput";
import type { ChoicesData } from "./ChoicesInput.types";
import type { GenUIRenderer } from "./registry";

/**
 * Maps an interactive GenUI `component` name to its renderer. Each entry localizes
 * the cast from the untyped wire props to the component's typed props. Add new
 * interactive components here.
 */
export const genUIInputRegistry: Record<string, GenUIRenderer> = {
  render_choices: (props) => <ChoicesInput {...(props as unknown as ChoicesData)} />,
};
